import React from "react";

export default function PromiseSection({
  subtitle,
  title,
  description,
  leftIcon,
  rightIcon,
}) {
  return (
    <section className="promise-section position-relative py-5">
      <div className="container text-center position-relative">
        <p className="text-success FS40FW600">{subtitle}</p>

        <h2 className="main-title FS40FW600">{title}</h2>

        <p className="promise-description plus-sans FS18FW400 fw-700">{description}</p>
      </div>
    </section>
  );
}
